/**
	*	@class - WDHistory
	*	@desc - a wrapper for the window.history object, along with the ability to supplement
	          the history queue based on panes
	*/

import WDElement from '../gui/wd-element';

//extend wdelement so we can throw events	
export default class WDHistory extends WDElement {

	#history = window.history;
	#location = window.location;
	#controller;
	
	constructor()
	{
		super();
		
		//makes the back button work
		window.addEventListener('popstate',(evt) => this.trigger('history:back') );

		this.#controller = document.querySelector('wd-site-controller');
		this.#controller.on('pane:added',(evt) => this.handlePaneAdded(evt) );
		this.#controller.on('pane:removed',(evt) => this.handlePaneRemoved(evt) );
	};
	
	get state() { return this.#history.state; };
	get title() { return this.#history.title; };
	set title(newTitle) { document.title = newTitle; };

	replace(params)
	{
 		this.#history.replaceState(params,params.title,params.uri);		//push onto history stack
 		this.title = params.title;
	};

	push(params)
	{
		this.#history.pushState(params, params.title, params.uri);
		this.title = params.title;
	};

	/**
	 * adds pane info to the stack when it's added
	 * @param {*} evt 
	 */
	handlePaneAdded(evt)
	{
		const pane = evt.detail.pane;
		const params = pane.appConfig;

		if ( params.transition == 'push' )
		{
			this.push(params);
		}
		else if (params.transition == 'replace')
		{
			this.replace(params);
		}		

		pane.on('title:updated', (evt) => this.title = evt.detail.title);	
	};

	/**
	 * called when a pane is popped.  verifies our browser state and
	 * newly popped-to pane state match
	 */
	handlePaneRemoved(evt)
	{
		
		const fromPane = evt.detail.pane;
		const toPane = this.#controller.currentPane;

		//if the current state doesn't match our toPane, update it
		if (toPane && this.state.uri != toPane.appConfig.uri)
		{
			this.replace(toPane.appConfig);
		}

	};

};

customElements.define('wd-history',WDHistory);

